import api from "@/services/api";
import router from "@/router";
import l10n from "@/services/l10n";
import errorHandler from "@/services/errorHandler";

import {
  REMOVE_USER,
  SET_USER,
  SET_PASSWORD_RESET_DATA
} from "@/store/mutation-types";

export default {
  async login({ commit, dispatch, getters }, user = {}) {
    try {
      const { payload } = await api.auth.login(user);

      api.setAuthorizationHeader(`Bearer ${payload.token}`);

      commit(SET_USER, payload);
      dispatch("modal/close", null, { root: true });
      dispatch("playlists/fetch", {}, { root: true });

      if (user.remember) {
        localStorage.setItem("user", JSON.stringify(getters.user));
      } else {
        sessionStorage.setItem("user", JSON.stringify(getters.user));
      }

      return { error: null, payload };
    } catch (error) {
      return { error: errorHandler.form(error), payload: null };
    }
  },
  async register({ dispatch }, { user = {}, type = "" }) {
    try {
      const defaultMessage = l10n("REGISTER_SUCCESS");
      const action = type === "artist" ? "registerArtist" : "register";
      const { payload } = await api.auth[action](user);
      const { message = defaultMessage } = payload;

      this.$app.$success(message);

      dispatch("modal/close", null, { root: true });

      if (router.currentRoute.path !== "/") {
        router.push("/").catch(() => {});
      }

      return { error: null, payload };
    } catch (error) {
      return { error: errorHandler.form(error), payload: null };
    }
  },
  async forgotPassword(_, params) {
    try {
      const { payload } = await api.auth.forgotPassword(params);
      const { message = l10n("RECOVER_PASSWORD_LINK_SENDED") } = payload;

      return this.$app.$info(message), { error: false, payload };
    } catch (error) {
      return this.$app.$error(error), { error: true, payload: null };
    }
  },
  async resetPassword(_, params) {
    try {
      const { payload } = await api.auth.resetPassword(params);
      const { message = l10n("PASSWORD_WAS_RESET") } = payload;

      return this.$app.$info(message), { error: false, payload };
    } catch (error) {
      return this.$app.$error(error), { error: true, payload: null };
    }
  },
  async setPasswordResetData({ commit }, data) {
    commit(SET_PASSWORD_RESET_DATA, data);
  },
  async verify({ commit, getters }, token = "") {
    try {
      const { payload } = await api.auth.verify({
        token
      });

      commit(SET_USER, payload);

      api.setAuthorizationHeader(`Bearer ${payload.token}`);
      localStorage.setItem("user", JSON.stringify(getters.user));

      return payload;
    } catch (error) {
      router.push("/").catch(() => {});

      return errorHandler.form(error);
    }
  },
  async logout({ commit, dispatch }) {
    try {
      commit(REMOVE_USER);
      dispatch("playlists/clear", null, { root: true });

      localStorage.removeItem("user");
      sessionStorage.removeItem("user");

      await api.auth.logout();

      api.deleteAuthorizationHeader();

      this.$app.$player.clearQueue();

      return true;
    } catch (error) {
      return errorHandler.add(error);
    }
  },
  async complain({ dispatch }, form) {
    try {
      await api.user.complain(form);

      this.$app.$success(l10n("COMPLAIN_SENDED"));
    } catch (errors) {
      this.$app.$error(l10n("CANT_SEND_MESSAGE"));
    }

    dispatch("modal/close", null, { root: true });
  }
};
